<template>
    <ancestryline-modal title="audit.modal-title"  id="audit-modal" :close="true" @close="close" :loading="false">

        <card>
            <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
        </card>

        <template #footer>
            <Button class="p-mr-2" @click="close()">{{$t('btn.close')}}</Button>
        </template>
    </ancestryline-modal>
</template>

<script>
    import DialogService from "@/business/ModalBusiness";
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";

    export default {
        name: "Audit",
        components: {AncestrylineDataTable},
        props: ["business"],
        methods: {
            close(){
                DialogService.closeModal();
            },
        },

        data() {
            return {
                dataFunction: this.business.audit,
                columns: [
                    {field: "name", header: 'dataTable.audit.columns.name', sortable:true},
                    {field: "entity", header: 'dataTable.audit.columns.entity', sortable:false},
                    {field: "created", header: 'dataTable.audit.columns.created', sortable:true, type: 'date-time'},
                    {field: "operation", header: 'dataTable.audit.columns.operation', sortable:true},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                            {icon: 'pi pi-eye', title: 'dataTable.audit.columns.look', function: () => {}},
                        ]
                    },
                ]
            }
        },

    }
</script>

<style scoped>

</style>